import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "./store";

const initialState = {
  accessPoint: null,
  accessPoints: [],
  organisation: null,
  accessPointId: null,
};

const accessOrgSlice = createSlice({
  name: "accessOrg",
  initialState,
  reducers: {
    setAccessPoint: (state, action) => {
      state.accessPoint = action.payload;
    },
    setOrganisation: (state, action) => {
      state.organisation = action.payload;
    },
    setAccessPointId: (state, action) => {
      state.accessPointId = action.payload;
    },
    setAccessPoints: (state, action) => {
      state.accessPoints = action.payload || [];
    },
  },
});

export const getAccessPoint = (
  state: RootState,
  initialAccessPoint: string = null
) => {
  return state.accessOrg.accessPoint || initialAccessPoint;
};

export const getOrganisation = (
  state: RootState,
  initialOrganisation: string = null
) => {
  return state.accessOrg.organisation || initialOrganisation;
};
export const getAccessPointId = (
  state: RootState,
  initialAccessPointId: string = null
) => {
  return state.accessOrg.accessPointId || initialAccessPointId;
};

export const getAccessPoints = (
  state: RootState,
  initialAccessPoints: any[] = []
) => {
  return state.accessOrg.accessPoints.length
    ? state.accessOrg.accessPoints
    : initialAccessPoints;
};

export const {
  setAccessPoint,
  setOrganisation,
  setAccessPoints,
  setAccessPointId,
} = accessOrgSlice.actions;

export default accessOrgSlice.reducer;
